import { render, staticRenderFns } from "./VisitorDuplicateList.vue?vue&type=template&id=4c84e6d6"
import script from "./VisitorDuplicateList.vue?vue&type=script&lang=js"
export * from "./VisitorDuplicateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports